import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'table',
    `
			border-collapse: collapse;
			min-width: 100%;
		`
  ],

  [
    'tr',
    theme => `
			&:nth-of-type(even) {
				background: ${theme.survey.color.light};
			}
		`
  ],

  [
    'th',
    `
			vertical-align: bottom;
			font-weight: 300;
		`
  ],
  [
    'thtd',
    `
      :lang(ar){
        transform: scaleX(-1);
        direction: rtl;
      }
		`
  ],
  [
    'firstColumn',
    `
			min-width: 6em;
		`
  ],
  [
    'withPadding',
    `
   	 padding: 16px 8px;
		`
  ],
  [
    'center',
    `
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		`
  ],
  [
    'radioClassName',
    `
			border: none;
			background-color: transparent;

			width: 100%;
			height: 100%;
			padding: 0;
			margin: 0;

			> span {
				width: 36px;
				margin: 0 auto;
			}
		`
  ],
  [
    'textClassName',
    theme => [
      `
        font-size: 1em;
        color: ${theme.survey.color.default};
			`
    ]
  ],
  [
    'categoryText',
    theme => [
      `
        :lang(ar){
          transform: scaleX(-1);
          direction: rtl;
        }
				line-height: 1.5;
				font-size: 1em;
				font-weight: 300;
				color: ${theme.survey.color.black};
 
				margin: 0 0 10px 0;
			`
    ]
  ],
  [
    'categoryTextContainer',
    `
			position: relative;
			margin: 0 0 0 10px;
		`
  ]
]);
